import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Helper } from "../core/util/helper";
import { WellKnownSigneeRole } from "./editRole";
import { RoleViewModel } from "./signatureGrid";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class EditSignature extends React.Component<EditSignatureProps, any> {
    common = new AppHelper();
    translations = {};
    infoText: string;
    showInfoText: boolean;

    constructor(props: EditSignatureProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.props.context.dataSources = props.dataSources;
        this.showInfoText = false;
    }

    save = () => {
        if (this.common.validate()) {
            this.common.handlePostSave(true, true);
            this.setState({});
        }
    }
    
    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Role":
                this.handleRoleChange(value, dataItem);
                break;
            case "entity.UniqueName":
                if (!this.props.isNameUnique(value)) {
                    value = this.props.entity.UniqueName;
                }
                break;
            case "entity.Reasons":
                if (!Helper.hasValue(value))
                    value = {};
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private handleRoleChange = (value: number, dataItem: RoleViewModel) => {
        //Prüfen ob Rolle bereits vergeben ist
        let index = this.props.context.usedRoles.findIndex(f => f == value);
        if (index > -1) {
            this.showInfoText = true;
            this.infoText = this.translations["WebSMS.ReportMetadata.SigneeRoleAlreadyExists"];
            this.infoText = this.infoText.replace("{role}", dataItem.Value);
            NotificationHelper.showInfoMessage(this.infoText);
        } else {
            this.showInfoText = false;
        }
        //Rolen erweitern
        index = this.props.dataSources.roles.findIndex(f => f.Key == value);
        if (index == -1) {
            this.props.dataSources.roles.push(dataItem);
            this.setState({}, () => {
                let entity = this.props.entity;
                entity.Role = dataItem.Key;
                Helper.updateEntity(this.props.entity, entity);
                this.common.setEntityDirtyState(true);
                this.setState({});
            })
        }
        //UniqueName setzten
        let uniqueName: string;
        switch (dataItem.WellKnownSigneeRole) {
            case WellKnownSigneeRole.Customer:
                uniqueName = this.props.uniqueNames.customer;
                break;
            case WellKnownSigneeRole.Dispatcher:
                uniqueName = this.props.uniqueNames.dispatcher;
                break;
            case WellKnownSigneeRole.Technician:
                uniqueName = this.props.uniqueNames.technician;
                break;
            default:
                uniqueName = this.props.uniqueNames.other;
                break;
        }
        this.handleFieldChange({ model: "entity.UniqueName" }, uniqueName );
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.getTranslation("WebSMS.ReportMetadata.Sig"))
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}

export interface EditSignatureContext extends Context {
    translations?: StringKeyDictionary<string>;
    usedRoles: number[];
    dataSources?: {
        roles: KeyValuePair<number, string>[]
    }
}

export interface EditSignatureProps extends AppBaseProps {
    entity: SignatureEntity;
    context: EditSignatureContext;
    dataSources: {
        roles: RoleViewModel[]
    },
    uniqueNames: {
        technician: string;
        customer: string;
        dispatcher: string;
        other: string;
    },
    isNameUnique: (name: string) => boolean;
}

export interface SignatureEntity extends Entity{
    GridId: string;
    UniqueName: string;
    Role: number;
    DefineByQuickReport: boolean;
    Top: number;
    Left: number;
    Height: number;
    Width: number;
    Page: number;
    Mandatory: boolean;
    AdditionalCompanyField: boolean;
    Reasons: {};
    WellKnownSigneeRole?: WellKnownSigneeRole;
}